import request from "@/plugin/axios";
import axios from "axios";
import util from "@/libs/util";
const token = util.cookies.get("token");

export function page(query) {
  return request({
      url: '/api/case/czCaseInfo/deleteCaseList',
      method: 'post',
      data: query
  })
}

export function recoverCase(id) {
  return request({
      url: '/api/case/czCaseInfo/recoverCase/' + id,
      method: 'post'
  })
}